/* Mirrors the original `ButtonGroup` (soft-filled container with a thin
 * border and a primary-tinted active pill). Tokens match the design
 * system so theming flows through automatically. */
.root {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  background-color: var(--background-soft);
  border: 1px solid var(--border-soft);
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}

.option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border: 0;
  background: transparent;
  color: var(--text-default);
  font: inherit;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 120ms ease, color 120ms ease;
}

.option:hover:not(.active) {
  background: var(--surface-hover);
}

.option.active {
  color: var(--text-primary);
  background: var(--action-primary-soft-hover);
}

.option.active:hover {
  background: var(--action-primary-soft-hover);
}
